export const apiUrl = process.env.API_URL
export const analytics = process.env.ANALYTICS
export const env = process.env


// WEBPACK FOOTER //
// ./src/config.js